import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CrudList from "@/components/CrudList";

export default function Produksi() {
  const [sites, setSites] = useState([]);
  useEffect(() => { api.get("/sites").then((r) => setSites(r.data)); }, []);
  return (
    <CrudList
      title="Produksi Tambang"
      subtitle="Input tonase harian per site & material"
      endpoint="/produksi"
      exportModule="produksi"
      columns={[
        { key: "date", label: "Tanggal" },
        { key: "site_id", label: "Site", render: (r) => sites.find((s) => s.id === r.site_id)?.name || "-" },
        { key: "material", label: "Material" },
        { key: "tonase", label: "Tonase", render: (r) => (r.tonase || 0).toLocaleString('id-ID') + " ton" },
        { key: "ritase", label: "Ritase" },
      ]}
      fields={[
        { key: "date", label: "Tanggal", type: "date", required: true },
        { key: "site_id", label: "Site", type: "select", options: sites.map((s) => ({ value: s.id, label: s.name })), required: true },
        { key: "material", label: "Material", type: "select", options: [
          { value: "coal", label: "Batubara" },
          { value: "ore", label: "Bijih" },
          { value: "overburden", label: "Overburden" },
          { value: "nikel", label: "Nikel" },
          { value: "emas", label: "Emas" },
        ], required: true },
        { key: "tonase", label: "Tonase (ton)", type: "number", required: true },
        { key: "ritase", label: "Ritase", type: "number" },
        { key: "note", label: "Catatan", wide: true },
      ]}
    />
  );
}
